import { SVG, SVGProps } from './svg'

export function IconIdeaLoad(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M12 4a6 6 0 016 5 5.5 5.5 0 01-.5 11H6a5 5 0 010-10 6 6 0 016-6zm3.7 8.6l.2-.2c.2-.2.2-.5 0-.7L12.4 8a.5.5 0 00-.8 0l-3.5 3.6c-.2.2-.2.5 0 .7l.2.2.4.1H10v3.8c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5v-3.8h1.3l.4-.1z" />
    </SVG>
  )
}
